import { Modal } from "react-bootstrap";
import useTranslator from "../../../hooks/useTranslator";
import TenantContext from "../../../context/tenant/TenantContext";
import { useContext, useState } from "react";
import SkorDefaultLoader from "../../../assets/img/skorDefaultLoader.gif";
import AuthContext from "../../../context/auth/AuthContext";
import { toast } from "../../../helper/common";

const PendingRequestsFlatmate = ({
  show,
  pendingFlatmates,
  loadPendingFlatemates,
  loading,
  showBackground = false,
}) => {
  const { _t } = useTranslator();
  const { updateSharerStatus } = useContext(TenantContext);
  const { loadUserTenant } = useContext(AuthContext);
  const [processingIds, setProcessingIds] = useState(new Set());

  const handleAccept = async (sharer_id) => {
    if (processingIds.has(sharer_id)) return;
    setProcessingIds((prev) => new Set(prev).add(sharer_id));

    try {
      const payload = {
        sharer_id: sharer_id,
        status: "accepted",
      };
      await updateSharerStatus(payload);
      loadPendingFlatemates();
      loadUserTenant("tenant");
    } catch (e) {
      toast.error(
        e?.response?.data?.msg ??
          _t(
            "failedToAcceptRequest",
            "Text used in guarantees pending requests popup"
          )
      );
    } finally {
      setProcessingIds((prev) => {
        const updated = new Set(prev);
        updated.delete(sharer_id);
        return updated;
      });
    }
  };

  const handleReject = async (sharer_id) => {
    if (processingIds.has(sharer_id)) return;
    setProcessingIds((prev) => new Set(prev).add(sharer_id));

    try {
      const payload = {
        sharer_id: sharer_id,
        status: "rejected",
      };
      await updateSharerStatus(payload);
      loadPendingFlatemates();
    } catch {
      toast.error(_t("failedToRejectRequest"));
    } finally {
      setProcessingIds((prev) => {
        const updated = new Set(prev);
        updated.delete(sharer_id);
        return updated;
      });
    }
  };

  return (
    <Modal
      show={show}
      centered
      className={`wrapper-modal newmodalui asguarantor modal-lg pending-request-modal ${
        showBackground ? "modal-fixed-screen" : ""
      }`}
    >
      <Modal.Header>
        <Modal.Title className="pending-modal-title">
          {_t(
            "pendingFlatematesRequests",
            "Text used in guarantees pending requests popup"
          )}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className="text-center my-4">
            <img
              src={SkorDefaultLoader}
              className="defaultSkorLoader"
              alt="Example"
            />
          </div>
        ) : pendingFlatmates.length === 0 ? (
          <p className="text-center">
            {_t(
              "noPendingFlatematesFound",
              "Text used in flatemates pending requests popup"
            )}
          </p>
        ) : (
          <div className="d-flex flex-column gap-2 wrapper-pending-requests">
            {pendingFlatmates.map((request) => {
              const sharer_id = request?._id;
              const isProcessing = processingIds.has(sharer_id);

              return (
                <div
                  key={request._id}
                  className="d-flex justify-content-between align-items-center border rounded p-3"
                >
                  <div className="d-flex flex-column request-info">
                    <strong>
                      {request?.tenant_id?.fname ?? "N/A"}{" "}
                      {request?.tenant_id?.lname ?? ""}
                    </strong>
                    <small className="text-muted">
                      {request?.tenant_id?.email}
                    </small>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btnNext btncancle"
                      onClick={() => handleReject(request?._id)}
                      disabled={isProcessing}
                    >
                      <svg
                        className="me-1"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.8134 1.08759C13.8726 1.02843 13.9195 0.958196 13.9515 0.8809C13.9835 0.803604 14 0.720759 14 0.637094C14 0.55343 13.9835 0.470585 13.9515 0.393289C13.9195 0.315993 13.8726 0.24576 13.8134 0.1866C13.7542 0.127441 13.684 0.080513 13.6067 0.048496C13.5294 0.016479 13.4466 0 13.3629 0C13.2792 0 13.1964 0.016479 13.1191 0.048496C13.0418 0.080513 12.9716 0.127441 12.9124 0.1866L7 6.10029L1.08759 0.1866C1.02843 0.127441 0.958196 0.080513 0.8809 0.048496C0.803604 0.016479 0.720759 6.23348e-10 0.637094 0C0.55343 -6.23349e-10 0.470585 0.016479 0.393289 0.048496C0.315993 0.080513 0.24576 0.127441 0.1866 0.1866C0.127441 0.24576 0.080513 0.315993 0.048496 0.393289C0.016479 0.470585 -6.23348e-10 0.55343 0 0.637094C6.23349e-10 0.720759 0.016479 0.803604 0.048496 0.8809C0.080513 0.958196 0.127441 1.02843 0.1866 1.08759L6.10029 7L0.1866 12.9124C0.0671221 13.0319 0 13.1939 0 13.3629C0 13.5319 0.0671221 13.6939 0.1866 13.8134C0.306079 13.9329 0.468126 14 0.637094 14C0.806062 14 0.96811 13.9329 1.08759 13.8134L7 7.89971L12.9124 13.8134C13.0319 13.9329 13.1939 14 13.3629 14C13.5319 14 13.6939 13.9329 13.8134 13.8134C13.9329 13.6939 14 13.5319 14 13.3629C14 13.1939 13.9329 13.0319 13.8134 12.9124L7.89971 7L13.8134 1.08759Z"
                          fill="black"
                        />
                      </svg>
                      {_t("reject")}
                    </button>
                    <button
                      className="btnNext btnorange"
                      onClick={() => handleAccept(request?._id)}
                      disabled={isProcessing}
                    >
                      <svg
                        className="me-1"
                        width="16"
                        height="14"
                        viewBox="0 0 16 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16 1.26174L5.02857 12L0 7.0783L1.28914 5.81656L5.02857 9.46756L14.7109 0L16 1.26174Z"
                          fill="#253837"
                        />
                      </svg>
                      {_t("accept")}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default PendingRequestsFlatmate;
